import { CheckCircle2, Building2, Sparkles, Crown } from "lucide-react";

/**
 * VerifiedTierBadge — renders a tier-specific icon + label for the trust ladder:
 *   practitioner → gold check
 *   temple       → blue temple building
 *   initiate     → violet sparkles
 *   elder        → gold crown
 *
 * Pass `tier` (one of: "none" | "practitioner" | "temple" | "initiate" | "elder").
 * `compact` shows icon-only; otherwise icon + label.
 */
const TIER_META = {
  practitioner: {
    label: "Verified Practitioner",
    Icon: CheckCircle2,
    color: "text-secondary",
    fill: "fill-secondary text-background",
  },
  temple: {
    label: "Verified Temple",
    Icon: Building2,
    color: "text-blue-300",
    fill: "fill-blue-400/30 text-blue-200",
  },
  initiate: {
    label: "Verified Initiate",
    Icon: Sparkles,
    color: "text-violet-300",
    fill: "fill-violet-400/30 text-violet-200",
  },
  elder: {
    label: "Verified Elder",
    Icon: Crown,
    color: "text-secondary",
    fill: "fill-secondary text-background",
  },
};

export default function VerifiedTierBadge({ tier, size = 14, compact = false, className = "" }) {
  if (!tier || tier === "none") return null;
  const meta = TIER_META[tier];
  if (!meta) return null;
  const { label, Icon, color, fill } = meta;
  return (
    <span
      title={label}
      data-testid={`verified-tier-${tier}`}
      className={`inline-flex items-center gap-1 ${color} ${className}`}
    >
      <Icon size={size} strokeWidth={1.5} className={fill} />
      {!compact && (
        <span className="text-[10px] uppercase tracking-[0.16em] font-medium">{label}</span>
      )}
    </span>
  );
}
